/*
  Bräu Supply · typed-price converter (bs-fx.js)

  Prices typed into theme settings (FAQ answers, add-on cards, pills, spec rows) are US dollars.
  On a market that shops in another currency (brausupply.ca = CAD) this rewrites each typed
  "$1,234" into the shopper's currency using Shopify's own exchange rate (window.Shopify.currency),
  rounded up to the whole dollar the way the store rounds converted product prices, and labels it
  with the currency code: "$1,780 CAD".

  Left alone:
    - USD markets (brausupply.com) — nothing runs.
    - Amounts already followed by a currency code ("$2,668 CAD") — those are live prices.
    - Live price elements written by Shopify / bs-product.js (see SKIP).
    - "$2K"-style shorthand.
  Only runs inside Bräu Supply (bs-*) sections. Loaded from snippets/bs-styles.liquid.
*/
(function () {
  if (window.__bsFx) return;
  window.__bsFx = true;

  var cur = window.Shopify && window.Shopify.currency;
  if (!cur || !cur.active || cur.active === 'USD') return;
  var rate = parseFloat(cur.rate);
  if (!(rate > 0) || Math.abs(rate - 1) < 1e-9) return;
  var code = cur.active;

  var SKIP = [
    '[data-bs-live]', '[data-config-price-live]', '[data-price]', '[data-atc-price]', '[data-mobile-price]',
    '[data-ship-gap]', '[data-bundle-sel-price]', '.bs-bundle-price', '.bs-xsell-price', '.bs-addon-p', '.bs-cmp-p',
    '.bs-art-gcard-p', '.price', '.price__container', 'cart-drawer', 'cart-items', 'cart-notification',
    '.totals', 'script', 'style', 'noscript', 'textarea', 'input', 'select', 'option', '[contenteditable]'
  ].join(',');

  var NUM = '(\\d{1,3}(?:,\\d{3})+|\\d+)(?:\\.(\\d{2}))?';
  // $A  or  $A–B / $A-$B ranges; not followed by K/k shorthand or an existing currency code.
  var RE = new RegExp('\\$\\s?' + NUM + '(?:(\\s?[–-]\\s?)\\$?\\s?' + NUM + ')?(?!\\d|,\\d|\\.\\d|\\s?[Kk]\\b|\\s?(?:CAD|AUD|NZD|EUR|GBP|HKD|SGD|JPY|MXN)\\b)(\\s?USD\\b)?', 'g');

  var fmt0, fmt2;
  try {
    fmt0 = new Intl.NumberFormat('en-CA', { style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 0 });
    fmt2 = new Intl.NumberFormat('en-CA', { style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch (e) { return; }

  // Whole-dollar amounts round up to the whole unit (like the store's converted prices);
  // amounts typed with cents keep cents.
  function conv(intPart, cents) {
    var usd = parseFloat(intPart.replace(/,/g, '') + (cents ? '.' + cents : ''));
    if (!(usd > 0)) return null;
    return cents ? { v: Math.round(usd * rate * 100) / 100, c: true } : { v: Math.ceil(usd * rate - 1e-6), c: false };
  }

  function money(x) {
    var s = (x.c ? fmt2 : fmt0).format(x.v);   // "$1,780" for CAD, "€1,780" for EUR
    return s.replace(/^[A-Z]{1,3}(?=\$)/, '');  // drop "CA" / "US" prefixes some browsers add
  }

  function rewrite(text) {
    return text.replace(RE, function (m, a, aC, dash, b, bC) {
      // "US$1,234" is a stated US-dollar figure (competitor prices on comparison pages): leave it.
      var at = arguments[arguments.length - 2], src = arguments[arguments.length - 1];
      if (typeof at === 'number' && /US$/i.test(src.slice(Math.max(0, at - 2), at))) return m;
      var x = conv(a, aC);
      if (x == null) return m;
      if (b) {
        var y = conv(b, bC);
        if (y == null) return m;
        return money(x) + (dash || '–') + money(y).replace(/^[^\d]+/, '') + ' ' + code;
      }
      return money(x) + ' ' + code;
    });
  }

  // Only Bräu Supply sections (they carry bs-* classes). Shopify's own sections — product and
  // collection grids, filters, cart, customer account pages — already show live amounts.
  function roots() {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return [];
    return Array.prototype.filter.call(main.querySelectorAll('.shopify-section'), function (sec) {
      return !!sec.querySelector('[class^="bs-"],[class*=" bs-"]');
    });
  }

  function run() {
    roots().forEach(runIn);
  }

  function runIn(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('$') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest(SKIP)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var t = rewrite(n.nodeValue);
      if (t === n.nodeValue) return;
      n.nodeValue = t;
      // "<strong>$1,899</strong> USD" — the typed "USD" sits in the next text node; drop it.
      if (/\d\s[A-Z]{3}\s*$/.test(t)) {
        var nx = n.nextSibling || (n.parentElement && n.parentElement.lastChild === n ? n.parentElement.nextSibling : null);
        if (nx && nx.nodeType === 3 && /^\s*USD\b/.test(nx.nodeValue)) nx.nodeValue = nx.nodeValue.replace(/^(\s*)USD\b/, '$1').replace(/^\s+(?=[·,.)])/, ' ');
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
